<h2 mat-dialog-title>Confirmation Dialog</h2>
<mat-dialog-content>
  Are you sure you want to delete this context?
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
  <button mat-raised-button [mat-dialog-close]="true" color="primary">Confirm</button>
</mat-dialog-actions>
